module.exports = __webpack_public_path__ + "static/media/sac1trans.9ab1c6a8.png";